(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-faqs"] && !window.DesignMode) return;
  try {
    
var acc = document.getElementsByClassName("wishit-title_accor");
var i;
if(document.getElementsByClassName("wishit-eachFaq").length > 0){
  document.getElementsByClassName("wishit-eachFaq")[0].classList.toggle("open");
  document.getElementsByClassName("wishit-eachFaq")[0].classList.toggle("close");
}
  
for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    /* Toggle between adding and removing the "active" class,
    to highlight the button that controls the panel */
    this.closest(".wishit-eachFaq").classList.toggle("open");
    this.closest(".wishit-eachFaq").classList.toggle("close");
  });
}

  } catch(e) { console.error(e); }
})();
})();
